import { Component, OnDestroy, OnInit } from "@angular/core";
import { CasesService } from "../../cases.service";
import { MatDialog } from "@angular/material/dialog";
import { ReminderDialogComponent } from "../reminder-dialog/reminder-dialog.component";
import { ReminderRefreshService } from "../../reminderRefresh.service";
import { ApiService } from "app/main/module/common/service/api.service";
import { TimestampService } from "app/main/module/common/timeConstant.service";
import * as moment from "moment";
import { ReminderService } from "./reminder-popup.service";
import workerScript from "../../worker";
import { AppStateService } from "app/main/module/common/service/appstate.service";
import { filter, take } from "rxjs/operators";
import { BehaviorSubject } from "rxjs";
import { NavigationEnd, Router } from "@angular/router";

@Component({
    selector: "app-reminder-popup",
    templateUrl: "./reminder-popup.component.html",
    styleUrls: ["./reminder-popup.component.scss"],
})
export class ReminderPopupComponent implements OnInit, OnDestroy {
    allData: any[] = [];
    shownReminders = new Set<number>();
    dueTime: any;
    now: any;
    uniqueTimestamp: any;
    labTimezone: any;
    dueReminders: any;
    reminderPollingInterval: any;
    worker: Worker;
    private nowReady$ = new BehaviorSubject<boolean>(false);

    constructor(
        private caseService: CasesService,
        private dialog: MatDialog,
        private reminderRefreshService: ReminderRefreshService,
        private apiService: ApiService,
        public timeStampService: TimestampService,
        private reminderService: ReminderService,
        private appState: AppStateService,
        private router: Router
    ) {}

    ngOnInit() {
        this.labTimezone = localStorage.getItem("defaultTz");
        this.getUniqueTimeStamp();

        this.router.events
            .pipe(
                filter((event) => event instanceof NavigationEnd),
                filter(() => !this.isAuthPage(this.router.url)),
                take(1)
            )
            .subscribe(() => {
                this.appState
                    .getReadyState$()
                    .pipe(take(1))
                    .subscribe(() => {
                        this.initWorker();
                        this.nowReady$
                            .pipe(filter(Boolean), take(1))
                            .subscribe(() => {
                                this.getPendingReminder();
                            });
                    });
            });
    }

    getPendingReminder() {
        this.caseService.fetchPendingReminders().subscribe((res: any) => {
            if (res?.data) {
                // console.log(res.data);

                this.allData = res.data;
                if (this.allData?.length > 0) {
                    this.reminderService.setReminders(this.allData);
                } else {
                    console.warn(
                        "Reminder API returned empty. Keeping existing reminders."
                    );
                }

                const startOfDay = moment
                    .tz(this.now, this.labTimezone)
                    .startOf("day")
                    .valueOf();
                // console.log(startOfDay);

                const dueReminders = this.allData.filter((item) => {
                    this.dueTime = Number(item.next_due_date);
                    // console.log("now: ", this.now);
                    // console.log("Due: ", this.dueTime);

                    return (
                        this.dueTime <= this.now &&
                        // this.dueTime >= startOfDay &&
                        item.status != "Completed" &&
                        !this.reminderService.isShown(item?.id)
                    );
                });

                dueReminders.forEach((reminder) => {
                    this.reminderService.markAsShown(reminder.id);

                    const dialogRef = this.dialog.open(
                        ReminderDialogComponent,
                        {
                            disableClose: true,
                            width: "450px",
                            height: "auto",
                            data: { data: reminder, openWithButton: false },
                        }
                    );

                    dialogRef.afterClosed().subscribe(() => {
                        // this.reminderService.clear();
                        this.getPendingReminder();
                        this.reminderRefreshService.triggerRefresh();
                    });
                });
            }
        });
    }

    getUniqueTimeStamp() {
        this.timeStampService.timestamp$.subscribe((ts) => {
            this.uniqueTimestamp = ts;
            this.updateUniqueTimestamp();
        });
    }

    getTimeStamp() {
        try {
            const timezone = this.labTimezone || "UTC";

            const localNow = new Date();
            const labTime = moment.tz(localNow, timezone);
            this.now = labTime.valueOf();
        } catch (error) {
            console.error("Error in getTimeStamp:", error);

            this.now = new Date().getTime();
        }
    }

    startReminderPolling() {
        const startOfDay = moment
            .tz(this.now, this.labTimezone)
            .startOf("day")
            .valueOf();
        this.dueReminders = this.reminderService.getNextUnshownReminder();
        const dueTime = Number(this.dueReminders?.next_due_date);
        // console.log(this.now);
        if (
            this.now >= dueTime &&
            // dueTime >= startOfDay &&
            this.dueReminders?.status != "Completed" &&
            !this.reminderService.isShown(this.dueReminders?.id)
        ) {
            this.reminderService.markAsShown(this.dueReminders?.id);
            const dialogRef = this.dialog.open(ReminderDialogComponent, {
                disableClose: true,
                width: "450px",
                height: "auto",
                data: { data: this.dueReminders, openWithButton: false },
            });
            dialogRef.afterClosed().subscribe(() => {
                // this.reminderService.clear();
                this.getPendingReminder();
                this.reminderRefreshService.triggerRefresh();
            });
        }
    }

    ngOnDestroy(): void {
        // if (this.worker) {
        //     this.worker.terminate(); // Stop all polling
        // }
    }

    updateUniqueTimestamp(): void {
        if (this.uniqueTimestamp) {
            // this.uniqueTimestamp += 1000;

            const labTime = moment.tz(this.uniqueTimestamp, this.labTimezone);
            this.now = labTime.valueOf();
            // console.log('nowInside: ',this.now);

            if (!this.nowReady$.value && this.now) {
                this.nowReady$.next(true);
            }
        } else {
            this.timeStampService.initLocalTimestamp(this.labTimezone);
        }
    }

    initWorker() {
        if (typeof Worker !== "undefined") {
            this.worker = new Worker(workerScript);

            this.worker.onmessage = ({ data }) => {
                if (data.type === "tick") {
                    if (data.label === "reminder") {
                        // console.log("Polling tick from worker:", data.label);
                        this.startReminderPolling();
                    }
                    // if (data.label === "updateTimer") {
                    //     // console.log("Polling tick from worker:", data.label);
                    //     this.updateUniqueTimestamp();
                    // }
                }
            };

            this.worker.postMessage({
                type: "start",
                label: "reminder",
                delay: 30000,
            });
            // this.worker.postMessage({
            //     type: "start",
            //     label: "updateTimer",
            //     delay: 1000,
            // });
        }
    }

    private isAuthPage(url: string): boolean {
        const authRoutes = ["/login", "/register", "/forgot-password"];
        return authRoutes.some((route) => url.startsWith(route));
    }
}
